export const accountsStatusKey = 'accountsStatus';
